<template lang="pug">
.navbar.gap-3.flex.items-center.justify-between.h-12.px-4.border-b.border-neutral.bg-white
    //- +++++++++++++++++++++++++++++++++++
    //- LARGE
    //- +++++++++++++++++++++++++++++++++++

    //- button sidebar
    .flex.self-center(v-if="store.mainSidebarValue === 0")
        UButton.cursor-pointer(
            icon="lucide:arrow-right-from-line"
            color="secondary"
            size="sm"
            variant="soft"
            @click="store.mainSidebar = 2"
        )

    //- button leftbar
    .flex.self-center(v-if="store.leftBarValue === 0 && store.leftbarAvailable")
        UButton.cursor-pointer(
            icon="akar-icons:sidebar-right"
            color="secondary"
            size="sm"
            variant="soft"
            @click="store.leftBar = 2"
        )

    //- button back
    .navbar-brand.flex-1.flex(
        class="sm:block hidden"
    )
        .flex.flex-1.justify-between
            .flex.self-center.flex-1.gap-3(v-if="title || !!$slots.title")

                slot(name="title")
                    .flex.self-center(v-if="!hideLink && $route.path !== '/'")
                        UButton.cursor-pointer(
                            :to="pageUp"
                            icon="mdi:chevron-left"
                            color="secondary"
                            size="sm"
                            variant="soft"
                        )
                    .flex.self-center(
                        v-if="title"
                    )
                        .flex.self-center.pt-1(class="font-bold text-sm text-gray-800 dark:text-gray-200 hover:text-gray-500 dark:hover:text-gray-400") {{ title }}

    //- +++++++++++++++++++++++++++++++++++
    //- Navbar Right
    //- +++++++++++++++++++++++++++++++++++
    .navbar-actions.flex.items-center.gap-3.flex-1(
        class="sm:justify-end justify-between"
    )
        BaseNavbarNotification.block(class="sm:hidden")
        //- BaseNavbarSearch
        .flex.gap-3.justify-end.flex-1(class="sm:flex-0")
            .flex.self-center(v-if="$slots.right")
                slot(name="right")
            BaseNavbarNotification.hidden(class="sm:block")
            BaseNavbarMenu
            .flex.self-center
                UButton(
                    variant="soft"
                    size="sm"
                    icon="material-symbols:fullscreen-rounded"
                    color="secondary"
                    @click="RFullScreen()"
                )

        //- button rightbar
        .flex.self-center(v-if="store.rightBarValue === 0 && store.rightbarAvailable")
            UButton.cursor-pointer(
                icon="akar-icons:sidebar-right"
                color="secondary"
                size="sm"
                variant="soft"
                @click="store.rightBar = 2"
            )
//- +++++++++++++++++++++++++++++++++++
//- SMALL
//- +++++++++++++++++++++++++++++++++++
.w-full.flex.block.bg-white(
    class="sm:hidden"
    :class="{'border-b': !cls.includes('border-0') && cls !== ''}"
)
    .flex.h-full.flex-1.justify-between(
        class="flex-col font-bold text-sm text-gray-800 dark:text-gray-200 hover:text-gray-500 dark:hover:text-gray-400"
        :class="{'flex-row border-b': row, 'border-b': cls === ''}"
    )
        .flex.flex-1.gap-3.px-4.py-2
            .flex.self-center(v-if="!hideLink && $route.path !== '/'")
                UButton.cursor-pointer(
                    icon="mdi:chevron-left"
                    color="secondary"
                    size="sm"
                    variant="soft"
                    :to="pageUp"
                )

            .flex.flex-1.self-center(
                v-if="title || !!$slots.title"
            )
                slot(name="title")
                    .word-wrap {{ title }}

slot(name="default")
</template>
<script setup lang="ts">
import { useRoute } from 'vue-router'
const store = useTemplateStore()
const props = defineProps<{
    title?: string
    hideLink?: boolean
    row?: boolean
    class?: string
    sidebar?: boolean
    right?: any
}>()
const route = useRoute()
const pageUp = ref('')
const cls = ref('')
onMounted(() => {
    const segments = route.path.split('/').filter(Boolean)
    pageUp.value = segments.length > 1 ? `/${segments.slice(0, -1).join('/')}` : '/'

    if (props.class) {
        cls.value = props.class.toString()
    }
})
</script>
